import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagramColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 10.5,
			height: 10.5,
			rx: 5.25,
			fill: "url(#paint0_radial_444_1469)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 10.5,
			height: 10.5,
			rx: 5.25,
			fill: "url(#paint1_radial_444_1469)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 10.5,
			height: 10.5,
			rx: 5.25,
			fill: "url(#paint2_radial_444_1469)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.625 3.9375C8.625 4.24816 8.37316 4.5 8.0625 4.5C7.75184 4.5 7.5 4.24816 7.5 3.9375C7.5 3.62684 7.75184 3.375 8.0625 3.375C8.37316 3.375 8.625 3.62684 8.625 3.9375Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 7.875C7.03553 7.875 7.875 7.03553 7.875 6C7.875 4.96447 7.03553 4.125 6 4.125C4.96447 4.125 4.125 4.96447 4.125 6C4.125 7.03553 4.96447 7.875 6 7.875ZM6 7.125C6.62132 7.125 7.125 6.62132 7.125 6C7.125 5.37868 6.62132 4.875 6 4.875C5.37868 4.875 4.875 5.37868 4.875 6C4.875 6.62132 5.37868 7.125 6 7.125Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25H6.15C7.41012 2.25 8.04018 2.25 8.52148 2.49524C8.94484 2.71095 9.28905 3.05516 9.50476 3.47852C9.75 3.95982 9.75 4.58988 9.75 5.85V6.15C9.75 7.41012 9.75 8.04018 9.50476 8.52148C9.28905 8.94484 8.94484 9.28905 8.52148 9.50476C8.04018 9.75 7.41012 9.75 6.15 9.75H5.85C4.58988 9.75 3.95982 9.75 3.47852 9.50476C3.05516 9.28905 2.71095 8.94484 2.49524 8.52148C2.25 8.04018 2.25 7.41012 2.25 6.15V5.85ZM5.85 3H6.15C6.79243 3 7.22915 3.00058 7.56672 3.02816C7.89553 3.05503 8.06369 3.10372 8.18099 3.16349C8.46323 3.3073 8.6927 3.53677 8.83651 3.81901C8.89628 3.93631 8.94497 4.10447 8.97184 4.43328C8.99942 4.77085 9 5.20757 9 5.85V6.15C9 6.79243 8.99942 7.22915 8.97184 7.56672C8.94497 7.89553 8.89628 8.06369 8.83651 8.18099C8.6927 8.46323 8.46323 8.6927 8.18099 8.83651C8.06369 8.89628 7.89553 8.94497 7.56672 8.97184C7.22915 8.99942 6.79243 9 6.15 9H5.85C5.20757 9 4.77085 8.99942 4.43328 8.97184C4.10447 8.94497 3.93631 8.89628 3.81901 8.83651C3.53677 8.6927 3.3073 8.46323 3.16349 8.18099C3.10372 8.06369 3.05503 7.89553 3.02816 7.56672C3.00058 7.22915 3 6.79243 3 6.15V5.85C3 5.20757 3.00058 4.77085 3.02816 4.43328C3.05503 4.10447 3.10372 3.93631 3.16349 3.81901C3.3073 3.53677 3.53677 3.3073 3.81901 3.16349C3.93631 3.10372 4.10447 3.05503 4.43328 3.02816C4.77085 3.00058 5.20757 3 5.85 3Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_444_1469",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(4.5 8.625) rotate(-55.3758) scale(9.56985)",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#B13589" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .79309,
						stopColor: "#C62F94"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#8A3AC8"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_444_1469",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(4.125 11.625) rotate(-65.1363) scale(8.47284)",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#E0E8B7" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .444662,
						stopColor: "#FB8A2E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .71474,
						stopColor: "#E2425C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E2425C",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_444_1469",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(0.187501 1.125) rotate(-8.1301) scale(14.5841 3.11938)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .156701,
						stopColor: "#406ADC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .467799,
						stopColor: "#6A45BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#6A45BE",
						stopOpacity: 0
					})
				]
			})
		] })
	]
});
export default SvgInstagramColor;
